document.addEventListener('DOMContentLoaded', function () {
  const goToTopBtn = document.getElementById('go-to-top-btn');
  const trailIcons = ['✦', '✧', '⭐', '★', '✏️', '📎'];

  window.addEventListener('scroll', function () {
    if (window.scrollY > 400) {
      goToTopBtn.classList.add('visible');
    } else {
      goToTopBtn.classList.remove('visible');
    }
  });

  goToTopBtn.addEventListener('click', function () {
    const btnRect = goToTopBtn.getBoundingClientRect();
    const startX = btnRect.left + btnRect.width / 2;
    const startY = btnRect.top + btnRect.height / 2;

    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    const padding = 50;

    goToTopBtn.classList.add('hidden-during-flight');

    const airplane = document.createElement('div');
    airplane.className = 'flying-airplane';
    airplane.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24" fill="currentColor"><path d="M2 21l21-9L2 3v7l15 2-15 2z"/></svg>';
    airplane.style.left = startX + 'px';
    airplane.style.top = startY + 'px';
    document.body.appendChild(airplane);

    const centerX = screenWidth / 2;
    const centerY = screenHeight / 2;
    const rx = centerX - padding;
    const ry = centerY - padding;

    const startAngle = Math.atan2(startY - centerY, startX - centerX);
    const numLoops = 1.5;
    const duration = 2200;
    const startTime = performance.now();
    let lastTrailTime = 0;
    let prevX = startX;
    let prevY = startY;

    const ellipseStartX = centerX + rx * Math.cos(startAngle);
    const ellipseStartY = centerY + ry * Math.sin(startAngle);

    function easeInOut(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    function animateFlight(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      let currentX, currentY;

      if (progress < 0.12) {
        const p = easeInOut(progress / 0.12);
        currentX = startX + (ellipseStartX - startX) * p;
        currentY = startY + (ellipseStartY - startY) * p;
      } else if (progress < 0.8) {
        const loopProgress = (progress - 0.12) / (0.8 - 0.12);
        const angle = startAngle + loopProgress * Math.PI * 2 * numLoops;
        const shrink = 1 - (loopProgress > 0.75 ? ((loopProgress - 0.75) / 0.25) * 0.3 : 0);
        currentX = centerX + rx * shrink * Math.cos(angle);
        currentY = centerY + ry * shrink * Math.sin(angle);
      } else {
        const p = easeInOut((progress - 0.8) / 0.2);
        const phaseStartAngle = startAngle + Math.PI * 2 * numLoops;
        const phaseStartX = centerX + rx * 0.7 * Math.cos(phaseStartAngle);
        const phaseStartY = centerY + ry * 0.7 * Math.sin(phaseStartAngle);
        currentX = phaseStartX;
        currentY = phaseStartY - p * (phaseStartY + 50);
      }

      currentX = Math.max(padding, Math.min(screenWidth - padding, currentX));
      currentY = Math.max(-50, Math.min(screenHeight - padding, currentY));

      const deltaX = currentX - prevX;
      const deltaY = currentY - prevY;
      const angleRad = Math.atan2(deltaY, deltaX);
      const angleDeg = (angleRad * 180) / Math.PI + 45;
      const bankTilt = Math.max(-15, Math.min(15, deltaX * 0.8));

      airplane.style.left = currentX + 'px';
      airplane.style.top = currentY + 'px';
      airplane.style.transform = `rotate(${angleDeg}deg) rotateX(${bankTilt}deg)`;
      airplane.style.opacity = 1 - progress * 0.15;

      if (elapsed - lastTrailTime > 40 && progress < 0.96) {
        lastTrailTime = elapsed;
        const particle = document.createElement('div');
        particle.className = 'airplane-trail-particle';
        particle.textContent = trailIcons[Math.floor(Math.random() * trailIcons.length)];
        particle.style.left = currentX + (Math.random() * 14 - 7) + 'px';
        particle.style.top = currentY + (Math.random() * 14 - 7) + 'px';
        document.body.appendChild(particle);

        setTimeout(function () {
          particle.remove();
        }, 700);
      }

      prevX = currentX;
      prevY = currentY;

      if (progress < 1) {
        requestAnimationFrame(animateFlight);
      } else {
        airplane.remove();
        goToTopBtn.classList.remove('hidden-during-flight');
      }
    }

    requestAnimationFrame(animateFlight);
    setTimeout(function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 150);
  });
});